// extracted by mini-css-extract-plugin
export default {"BlockLoader":"EUHXpMAN","container":"YdGrnFnV","box":"Lga3aLE8","icon":"gwjK3deM"};
    if(module.hot) {
      // 1776432161756
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  